import { lazy } from "react";

const routes = [
  {
    path: "/auditlogs",
    element: lazy(() => import("../pages/AuditLogs")),
  },
  {
    path: "/viewAuditLogs",
    element: lazy(() => import("../pages/AuditLogs/AuditLogsPage")),
  },
  {
    path: "/viewAuditLogs/:entityType/:entityId",
    element: lazy(() => import("../pages/AuditLogs/AuditLogsPage")),
  },
];

export default routes;
